import {ChartI, SchemaI} from "./Types";
import {Act287Charts} from "./287/Act287Charts";
import {act287Schema} from "./287/Act287";
import {act342Schema} from "./342/Act342";
import {act343Schema} from "./343/Act343";

const schemas = {
    'act287': act287Schema,
    'act342': act342Schema,
    'act343': act343Schema,
} as { [k: string]: SchemaI }

const charts_schemas = {
    'act287': Act287Charts
} as { [key: string]: { [key: string]: ChartI } }

export {schemas as STATIC_SCHEMAS, charts_schemas as STATIC_CHARTS}
